<template>
  <div class="login_wrap">
    <div class="login_box">
      <div class="login_con">
        <img class="left_img" src="../assets/images/login.png" />
        <div class="login_form_wrap">
          <h1><img src="../assets/images/login_logo.png" /></h1>
          <Form
            ref="formValidate"
            :model="formValidate"
            :rules="rules"
            class="login_form"
            @keyup.enter.native="loginSubmit('formValidate')"
          >
            <FormItem prop="username" ref="username">
              <Input
                v-model="formValidate.username"
                placeholder="请输入用户名"
              />
              <i class="iconfont icon-account login_icon"></i>
            </FormItem>
            <FormItem prop="password" ref="password">
              <Input
                v-model="formValidate.password"
                type="password"
                placeholder="请输入密码"
              />
              <i class="iconfont icon-password login_icon"></i>
            </FormItem>
            <div class="button_box">
              <div>{{ errorTip }}</div>
              <!-- <p>忘记密码？</p> -->
              <Button
                type="primary"
                @click="loginSubmit('formValidate')"
                :loading="loading"
                >登 录</Button
              >
            </div>
          </Form>
        </div>
      </div>
      <div class="copyright" v-if="isPro">
        <a href="http://beian.miit.gov.cn/">沪ICP备13030768号-77</a>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/common.css";
import cryptoJs from "crypto-js";
import { mapActions } from "vuex";
export default {
  data() {
    const validUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      isPro: false,
      errorTip: "",
      formValidate: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, validator: validUsername, trigger: "blur" },
        ],
        password: [
          { required: true, validator: validPassword, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.isPRO();
  },
  methods: {
    isPRO() {
      if (location.href.includes("miniapp.ishhm.com")) {
        this.isPro = true;
      } else {
        this.isPro = false;
      }
    },
    ...mapActions("account/", ["login"]),
    loginSubmit(formValidate) {
      this.$refs[formValidate].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.login({
            vm: this,
            username: this.formValidate.username,
            password: this.formValidate.password
              ? cryptoJs.MD5(this.formValidate.password)
              : "",
          })
            .then((res) => {
              this.loading = false;
              sessionStorage.setItem(
                "loginPhoneId",
                JSON.stringify({
                  loginEmpPhone: res.data.employee.employeePhone,
                  loginEmpId: res.data.employee.employeeId,
                })
              );
              this.$router.push({ name: this.$config.homeName });
            })
            .catch((e) => {
              this.loading = false;
              this.errorTip = e.message;
              console.log(e);
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.login_wrap {
  position: relative;
  min-width: 892px;
  height: calc(100vh);
  background: url(../assets/images/page_bg.png) left top;
}
.login_box {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 892px;
  margin-left: -446px;
  margin-top: -280px;
}
.login_con {
  border-radius: 8px;
  box-shadow: 0 0 15px #ddd;
  overflow: hidden;
}
.login_con .left_img {
  float: left;
}
.login_con .login_form_wrap {
  float: left;
  width: 570px;
  height: 420px;
  background-color: #fff;
}
.login_con h1 {
  padding: 35px 0 16px;
  text-align: center;
}
.login_form {
  width: 330px;
  margin: 30px auto 0;
}
.login_form .ivu-input {
  height: 45px;
  line-height: 45px;
}
.ivu-form-item {
  position: relative;
}
.login_icon {
  position: absolute;
  top: 8px;
  left: 10px;
  font-size: 20px;
}
.button_box div {
  height: 18px;
  line-height: 18px;
  color: #f00;
}
.button_box p {
  text-align: right;
  font-size: 14px;
  color: #ffbc82;
}
.button_box .ivu-btn {
  width: 100%;
  height: 45px;
  line-height: 45px;
  margin-top: 25px;
  padding: 0;
  font-size: 18px;
  background: url(../assets/images/button_bg.png) no-repeat;
  border: 0;
}
.copyright {
  position: fixed;
  bottom: 0;
  left: 50%;
  font-size: 14px;
  color: red;
  /* text-align: center; */
}
.copyright > a {
  color: #7d7d7d;
}
.beian {
  margin-top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue